<form #confirmationForm="ngForm" (ngSubmit)="submit()">
  <vnm-form-field [label]="'confirm-contact.input-info' | translate: { contact: method.value | contact }">
    <p-inputMask
      type="text"
      name="code"
      class="p-field-full-width"
      maxlength="7"
      pattern="\d{3}-\d{3}"
      [placeholder]="'confirm-contact.input-placeholder' | translate"
      [(ngModel)]="method.code"
      mask="999-999"
      autofocus
      [required]="true"
    ></p-inputMask>
  </vnm-form-field>
  <vnm-validation-errors [errors]="errors"></vnm-validation-errors>
  <p-panel
    [header]="'confirm-contact.contact-info' | translate"
    [collapsed]="true"
    [toggleable]="true"
    expandIcon="fa fa-plus"
    collapseIcon="fa fa-minus"
  >
    <div class="flex gap-md">
      <vnm-email-address [email]="method.value" *ngIf="method.notificationType === 'email'"></vnm-email-address>
      <vnm-phone-number [number]="method.value" *ngIf="method.notificationType === 'sms'"></vnm-phone-number>
      <button
        pButton
        type="button"
        [label]="'confirm-contact.resend-btn' | translate"
        icon="fa f-fw fa-undo"
        (click)="resendConfirmation()"
      ></button>
    </div>
  </p-panel>
  <vnm-form-actions direction="rtl" (cancel)="dialog.close()"></vnm-form-actions>
</form>
